<template>
<v-app>
  <v-form>
    <v-card>
      <v-card-title>
        <span class="headline" v-if="!offer.id">New offer</span>
        <v-layout v-else column ma-0>
          <span class="headline" v-if="offer.name && offer.name.en">Edit "{{ offer.name.en }}"</span>
          <span class="headline" v-else>New offer</span>
          <span style="font-size: 16px">
            {{ offer.id }} - Offer number
            <strong>{{offer.number}}</strong>
          </span>
        </v-layout>
        <v-spacer></v-spacer>
        <v-btn text icon @click="hideModal">
          <v-icon>close</v-icon>
        </v-btn>
      </v-card-title>
      <v-divider></v-divider>
      <v-card-text>
        <v-tabs v-model="currentTab" active-class="selected-tab" fixed-tabs background-color="#EEE">
          <v-tabs-slider color="blue"></v-tabs-slider>
          <v-tab key="1" href="#tab-1">General</v-tab>
          <v-tab key="2" href="#tab-2">Details</v-tab>
          <v-tab key="3" href="#tab-3">French</v-tab>

          <v-tabs-items v-model="currentTab">
            <v-tab-item key="1" value="tab-1">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs8>
                    <v-text-field
                      label="Offer Name*"
                      v-model.trim="offer.name.en"
                      v-validate="'required'"
                      :error-messages="errors.collect('offer name')"
                      data-vv-name="offer name"
                      required
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4>
                    <v-text-field
                      label="Offer Number*"
                      v-model.trim="offer.number"
                      v-validate="'required|integer'"
                      :error-messages="errors.collect('offernumber')"
                      data-vv-name="offernumber"
                      required
                      disabled
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="offer.partner"
                      :items="allPartners"
                      color="blue-grey lighten-4"
                      label="Select associated partner"
                      item-text="name"
                      item-value="id"
                      ref="offerPartners"
                      @blur="closeSelect('offerPartners')"
                      append-outer-icon="close"
                      @click:append-outer="clearOfferPartner"
                      :error-messages="errors.collect('partner')"
                      data-vv-name="partner"
                    ></v-select>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch v-model="offer.is_active" color="indigo" label="Offer active?"></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch
                      v-model="offer.is_business"
                      color="indigo"
                      label="Is business offer?"
                      @change="offer.categories = []"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs6>
                    <v-menu
                      v-model="dueDateMenu"
                      :close-on-content-click="false"
                      transition="scale-transition"
                      offset-y
                      max-width="290px"
                      min-width="290px"
                    >
                      <template v-slot:activator="{ on }">
                        <v-text-field
                          v-model="dueDate"
                          label="Valid until"
                          persistent-hint
                          prepend-icon="event"
                          v-on="on"
                          :hint="`Due date in Unixtime format: ${offer.valid_until}`"
                        ></v-text-field>
                      </template>
                      <v-date-picker
                        v-model="dueDate"
                        :min="new Date().toISOString()"
                        no-title
                        @input="dueDateMenu = false"
                      ></v-date-picker>
                    </v-menu>
                  </v-flex>
                  <v-flex xs6>
                    <v-switch
                      v-model="offer.is_featured"
                      color="indigo"
                      label="Offer featured in homepage?"
                    ></v-switch>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      v-validate="'url'"
                      label="Website URL"
                      v-model="offer.website_url"
                      :error-messages="errors.collect('offer.website_url')"
                      data-vv-name="offer.website_url"
                      placeholder="https://"
                      hint="Website URL including affiliate code"
                      type="text"
                      persistent-hint
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="Address*"
                      v-model="offerAddress"
                      :error-messages="errors.collect('address')"
                      data-vv-name="address"
                      id="autocomplete"
                      placeholder="Search"
                      class="search-location"
                      append-icon="close"
                      @click:append="clearOfferAddress"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    <v-select
                      v-model="offer.categories"
                      :items="allOfferCategories"
                      item-text="name"
                      item-value="id"
                      :menu-props="{ maxHeight: '400' }"
                      label="Select offer categories*"
                      v-validate="'required'"
                      :error-messages="errors.collect('categories')"
                      data-vv-name="categories"
                      ref="offerCategories"
                      @blur="closeSelect('offerCategories')"
                      multiple
                      hint="Select all categories related to this offer"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex xs12>
                    <v-combobox
                      v-model="offer.tags"
                      :items="tagItems"
                      hide-selected
                      hint="Create your own tags"
                      label="Offer tags for searching"
                      ref="offerTags"
                      @blur="closeSelect('offerTags')"
                      multiple
                      persistent-hint
                      small-chips
                      @input="processTag"
                    >
                      <template v-slot:no-data>
                        <v-list-item>
                          <v-list-item-title>
                            Press
                            <kbd>enter</kbd> to add new one
                          </v-list-item-title>
                        </v-list-item>
                      </template>
                      <template v-slot:selection="{ item, parent, selected }">
                        <v-chip label small>
                          <span class="pr-2">{{ item }}</span>
                          <v-icon small @click="parent.selectItem(item)">close</v-icon>
                        </v-chip>
                      </template>
                    </v-combobox>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item key="2" value="tab-2">
              <v-container grid-list-md>
                <v-layout row>
                  <v-flex xs3>
                    <img
                      alt="Thumbnail"
                      :src="offer.image.public_url"
                      v-if="offer.image"
                      width="100"
                      height="auto"
                    />
                  </v-flex>
                  <v-flex xs9>
                    <v-text-field
                      label="Offer image URL*"
                      :value="(offer.image && offer.image.public_url) ? offer.image.public_url : ''"
                      v-validate="'required'"
                      :error-messages="errors.collect('image')"
                      data-vv-name="image"
                      disabled
                      required
                    ></v-text-field>
                  </v-flex>
                </v-layout>
                <v-layout wrap>
                  <v-flex xs12>
                    <file-upload v-model="offer.image" :file-path="'offers'"></file-upload>
                    <file-selector v-model="offer.image" :file-path="'offers'"></file-selector>
                  </v-flex>
                </v-layout>
                <br />
                <v-layout wrap>
                  <v-flex xs12>
                    <v-select
                      v-model="offer.available_for"
                      :items="allBusinesses"
                      item-text="name"
                      item-value="id"
                      clearable
                      dense
                      ref="availableFor"
                      @blur="closeSelect('availableFor')"
                      :menu-props="{maxHeight:300}"
                      label="Available for these businesses*"
                      v-validate="'required'"
                      :error-messages="errors.collect('available_for')"
                      data-vv-name="available_for"
                      multiple
                      hint="Select all associated business that share this offer"
                    >
                      <template v-slot:append>
                        <v-icon
                          :color="offer.available_for && offer.available_for.length > 0 ? 'indigo darken-4' : ''"
                          ripple
                          @click="toggle"
                        >{{ icon }}</v-icon>Select all
                      </template>
                      <template v-slot:selection="{ item, index }">
                        <v-chip v-if="index <= 8">
                          <span>{{ item.name }}</span>
                        </v-chip>
                        <span
                          v-if="index === 8"
                          class="grey--text caption"
                        >(+{{ offer.available_for.length - 1 }} others)</span>
                      </template>
                    </v-select>
                  </v-flex>
                  <v-flex xs12>This offer will be available on*</v-flex>
                  <v-layout row wrap class="light--text" xs12>
                    <v-flex xs4 v-for="where in availableOn" :key="where.value">
                      <v-checkbox v-model="selected" :label="where.name" :value="where.value"></v-checkbox>
                    </v-flex>
                  </v-layout>
                  <v-flex xs8>
                    <v-select
                      :items="offerTypes"
                      label="Type*"
                      item-text="name"
                      item-value="value"
                      v-model.trim="offer.type"
                      v-validate="'required'"
                      :error-messages="errors.collect('type')"
                      data-vv-name="type"
                      required
                    ></v-select>
                  </v-flex>
                  <v-flex
                    xs4
                    v-if="offer.type === 'discount_amount' || offer.type === 'discount_percent'"
                  >
                    <v-text-field
                      :label="showDiscountLabel"
                      item-text="name"
                      item-value="value"
                      v-model.trim="offer.value"
                      v-validate="{ required_if: 'offer.type:discount_amount,discount_percent' , numeric: true, min_value: 1, max_value: maxAmount }"
                      :error-messages="errors.collect('discount')"
                      data-vv-name="discount"
                      :suffix="showDiscountSuffix"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs4 v-if="offer.type === 'discount_code'">
                    <v-text-field
                      :label="showDiscountLabel"
                      item-text="name"
                      item-value="value"
                      v-model.trim="offer.code"
                      v-validate="{required_if: 'offer.type:discount_code',alpha_dash:{allow_utf8_local_part:'en'},min:3,max:50}"
                      :error-messages="errors.collect('code')"
                      data-vv-name="code"
                      :suffix="showDiscountSuffix"
                      type="text"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    Content*
                    <vue-editor v-model="offer.content.en" :editorToolbar="customToolbar"></vue-editor>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
            <v-tab-item key="3" value="tab-3">
              <v-container grid-list-md>
                <v-layout wrap>
                  <v-flex xs12 sm12>
                    <span
                      style="font-size: 18px"
                      class="grey--text"
                    >Only used when the Business is not French by default.</span>
                  </v-flex>
                  <v-flex xs12>
                    <v-text-field
                      label="French offer name*"
                      v-model.trim="offer.name.fr"
                      :error-messages="errors.collect('french offer name')"
                      data-vv-name="french offer name"
                    ></v-text-field>
                  </v-flex>
                  <v-flex xs12>
                    French content*
                    <vue-editor v-model="offer.content.fr" :editorToolbar="customToolbar"></vue-editor>
                  </v-flex>
                </v-layout>
              </v-container>
            </v-tab-item>
          </v-tabs-items>
        </v-tabs>
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions>
        <small>*indicates required field</small>
        <v-spacer></v-spacer>
        <v-btn text @click="hideModal">Close</v-btn>
        <v-btn color="success" outlined @click="saveOffer">Save</v-btn>
      </v-card-actions>
    </v-card>
  </v-form>
</v-app>
</template>
<style>
</style>
<script>
import fb from "@/firebase";
import { mapMutations } from "vuex";
import GoogleMapsLoader from "google-maps";
import FileUpload from "@/components/FileUpload";
import FileSelector from "@/components/FileSelector";
import { VueEditor } from "vue2-editor";
import _ from "lodash";

GoogleMapsLoader.KEY = "AIzaSyBCYfCpdFlJJ8z6iLeojhzVS5_MdpI_-SU";
GoogleMapsLoader.LIBRARIES = ["places"];
GoogleMapsLoader.VERSION = "3.36";

const businesses = fb.db.collection("business_profiles");
const partners = fb.db.collection("partner_profiles");
const offers = fb.db.collection("partner_offers");

export default {
  name: "OfferForm",
  components: {
    VueEditor,
    FileUpload,
    FileSelector
  },
  props: {
    offer: Object
  },
  data: function() {
    return {
      loading: false,
      offerTypes: [
        {
          value: "no_discount",
          name: "Without discount"
        },
        {
          value: "discount_percent",
          name: "Discount (%)"
        },
        {
          value: "discount_amount",
          name: "Discount (amount)"
        },
        {
          value: "discount_code",
          name: "Coupon / code"
        }
      ],
      availableOn: [
        {
          value: "mobile",
          name: "Mobile app"
        },
        {
          value: "consumer",
          name: "Website B2C"
        },
        {
          value: "business",
          name: "Website B2B"
        }
      ],
      autoUpdate: true,
      allPartners: [],
      allBusinesses: [],
      offerCategories: [
        {
          name: "Wellness",
          id: "wellness"
        },
        {
          name: "Ticketing",
          id: "ticketing"
        },
        {
          name: "Gifts",
          id: "gifts"
        },
        {
          name: "High tech",
          id: "high-tech"
        },
        {
          name: "Utility",
          id: "utility"
        },
        {
          name: "Services",
          id: "services"
        },
        {
          name: "Flash offers",
          id: "flash"
        },
        {
          name: "Inevitable offers",
          id: "inevitable"
        }
      ],
      offerBusinessCategories: [
        {
          name: "Business events",
          id: "events"
        },
        {
          name: "Business services",
          id: "services"
        },
        {
          name: "Business team-building",
          id: "team-building"
        }
      ],
      offerAddress: "",
      selected: [],
      currentTab: "tab-1",
      customToolbar: [
        [{ header: [1, 2, 3, 4, 5, 6, false] }],
        ["bold", "italic", "underline"],
        [{ list: "ordered" }, { list: "bullet" }],
        ["code-block"]
      ],
      tagItems: [],
      dueDateMenu: false,
      dueDate: "",
      maxAmount: 10000
    };
  },
  computed: {
    allOfferCategories() {
      if (this.offer.is_business) {
        return this.offerBusinessCategories;
      } else {
        return this.offerCategories;
      }
    },
    allSelectedBusinesses() {
      return (
        this.offer &&
        this.offer.available_for &&
        this.offer.available_for.length === this.allBusinesses.length
      );
    },
    partiallySelectedBusinesses() {
      return (
        this.offer &&
        this.offer.available_for &&
        this.offer.available_for.length > 0 &&
        !this.allSelectedBusinesses
      );
    },
    icon() {
      if (this.allSelectedBusinesses) return "check_box";
      if (this.partiallySelectedBusinesses) return "indeterminate_check_box";
      return "check_box_outline_blank";
    },
    showDiscountLabel() {
      //Default to discount_code
      let label = "Code";
      if (this.offer.type === "discount_percent") {
        label = "Percent (%)*";
      } else if (this.offer.type === "discount_amount") {
        label = "Amount (€)*";
      }
      return label;
    },
    showDiscountSuffix() {
      // Default to discount_code
      let suffix = "";
      if (this.offer.type === "discount_percent") {
        suffix = "%";
      } else if (this.offer.type === "discount_amount") {
        suffix = "€";
      }
      return suffix;
    },
    dueDateFormatted() {
      if (this.dueDate) {
        let event = new Date(this.dueDate);
        event.setHours(23, 59, 0, 0);
        return Math.floor(event.getTime() / 1000);
      } else {
        return 0;
      }
    }
  },
  firestore: {
    partners: partners,
    offers: offers,
    businesses: businesses
  },
  watch: {
    selected: {
      handler: function(val) {
        if (val) {
          this.offer.available_on = val;
        } else {
          this.offer.available_on = [];
        }
      },
      immediate: true
    },
    offer: function(val) {
      if (val) {
        if (val.address && val.address.formatted_address) {
          this.offerAddress = val.address.formatted_address;
        }
        if (val.available_on) {
          this.selected = val.available_on;
        }
        if (val.valid_until) {
          this.dueDate = new Date(val.valid_until * 1000)
            .toISOString()
            .substr(0, 10);
        }
        if (val.type === "discount_percent") {
          this.maxAmount = 100;
        } else {
          this.maxAmount = 10000;
        }
        if (val.name && val.name.en) {
          this.offerNameEn = val.name.en;
        }
        if (val.name && val.name.fr) {
          this.offerNameFr = val.name.en;
        }
        if (val.content && val.content.en) {
          this.offerContentEn = val.content.en;
        }
        if (val.content && val.content.fr) {
          this.offerContentFr = val.content.fr;
        }
      }
    },
    dueDateFormatted(val) {
      if (val) {
        this.offer.valid_until = val;
      }
    }
  },
  mounted: function() {
    partners.get().then(querySnapshot => {
      this.allPartners = querySnapshot.docs.map(doc =>
        Object.assign({}, { id: doc.id }, doc.data())
      );
    });
    businesses
      .where("is_active", "==", true)
      .get()
      .then(querySnapshot => {
        this.allBusinesses = querySnapshot.docs.map(doc =>
          Object.assign({}, { id: doc.id }, doc.data())
        );
      });
    GoogleMapsLoader.load(google => {
      this.autocomplete = new google.maps.places.Autocomplete(
        document.getElementById("autocomplete"),
        {}
      );
      this.autocomplete.addListener("place_changed", () => {
        const place = this.autocomplete.getPlace();
        this.offerAddress = place.formatted_address;
        if (!this.offer.address) {
          this.offer.address = {};
        }
        this.offer.address.formatted_address = place.formatted_address;
        this.offer.address.place_id = place.place_id;
        this.offer.address.placeName = place.formatted_address;
        this.offer.address.lat = place.geometry.location.lat();
        this.offer.address.lng = place.geometry.location.lng();
        place.address_components.forEach(component => {
          if (component.types[0] === "country") {
            this.offer.address.country_name = component.long_name;
            this.offer.address.country_code = component.short_name;
          }
          if (component.types[0] === "administrative_area_level_1") {
            this.offer.address.state = component.long_name;
          }
          if (component.types[0] === "postal_code") {
            this.offer.address.postal_code = component.short_name;
          }
          if (component.types[0] === "locality") {
            this.offer.address.city = component.short_name;
          }
        });
        //console.log(this.offer.address);
      });
    });
    if (this.offer.type === "discount_percent") {
      this.maxAmount = 100;
    } else {
      this.maxAmount = 10000;
    }
  },
  methods: {
    closeSelect(name) {
      console.log("Close select: ", name);
      this.$refs[name].blur();
    },
    ...mapMutations(["setAppAlert"]),
    clearOfferAddress() {
      console.log("Clear address");
      this.offerAddress = "";
      this.offer.address = {};
    },
    clearOfferPartner() {
      this.offer.partner = "";
    },
    getAllWheres: function() {
      const wheres = [];
      this.availableOn.forEach(where => wheres.push(where.value));
      return wheres;
    },
    remove(item) {
      const index = this.partner.indexOf(item.code);
      if (index >= 0) this.partner.splice(index, 1);
    },
    saveOffer: function() {
      //console.log(this.offer);
      this.$validator.validateAll().then(result => {
        this.offer.created = this.offer.created
          ? this.offer.created
          : Math.floor(Date.now() / 1000);
        this.offer.code = this.offer.code ? this.offer.code.toUpperCase() : "";
        this.offer.value = this.offer.value ? parseInt(this.offer.value) : 0;
        if (result) {
          if (!this.offer.id) {
            offers
              .add(this.offer)
              .then(() => {
                this.setAppAlert({
                  visible: true,
                  text: "The offer has been created",
                  color: "success"
                });
                this.hideModal();
              })
              .catch(error => {
                this.setAppAlert({
                  visible: true,
                  text: error.message
                });
              });
          } else {
            offers
              .doc(this.offer.id)
              .update(this.offer)
              .then(() => {
                this.setAppAlert({
                  visible: true,
                  text: "The offer has been updated",
                  color: "success"
                });
                this.hideModal();
              })
              .catch(error => {
                this.setAppAlert({
                  visible: true,
                  text: error.message
                });
              });
          }
          return;
        } else {
          this.setAppAlert({
            visible: true,
            text: "Some required fields are incomplete or invalid",
            color: "error"
          });
        }
      });
    },
    hideModal() {
      //this.offer.name = "";
      //this.offer.frontChannelId = "";
      this.$emit("close");
    },
    toggle() {
      this.$nextTick(() => {
        if (this.allSelectedBusinesses) {
          this.offer.available_for = [];
        } else {
          this.offer.available_for = this.allBusinesses.map(b => b.id);
        }
      });
    },
    processTag(tag) {
      if (tag) {
        this.offer.tags = this.tagItems = _.union(
          tag.map(t => this.slugify(t, ""))
        );
      }
      //console.log(tag);
    },
    slugify(text, separator) {
      text = text
        .toString()
        .toLowerCase()
        .trim();

      const sets = [
        { to: "a", from: "[ÀÁÂÃÄÅÆĀĂĄẠẢẤẦẨẪẬẮẰẲẴẶ]" },
        { to: "c", from: "[ÇĆĈČ]" },
        { to: "d", from: "[ÐĎĐÞ]" },
        { to: "e", from: "[ÈÉÊËĒĔĖĘĚẸẺẼẾỀỂỄỆ]" },
        { to: "g", from: "[ĜĞĢǴ]" },
        { to: "h", from: "[ĤḦ]" },
        { to: "i", from: "[ÌÍÎÏĨĪĮİỈỊ]" },
        { to: "j", from: "[Ĵ]" },
        { to: "ij", from: "[Ĳ]" },
        { to: "k", from: "[Ķ]" },
        { to: "l", from: "[ĹĻĽŁ]" },
        { to: "m", from: "[Ḿ]" },
        { to: "n", from: "[ÑŃŅŇ]" },
        { to: "o", from: "[ÒÓÔÕÖØŌŎŐỌỎỐỒỔỖỘỚỜỞỠỢǪǬƠ]" },
        { to: "oe", from: "[Œ]" },
        { to: "p", from: "[ṕ]" },
        { to: "r", from: "[ŔŖŘ]" },
        { to: "s", from: "[ßŚŜŞŠ]" },
        { to: "t", from: "[ŢŤ]" },
        { to: "u", from: "[ÙÚÛÜŨŪŬŮŰŲỤỦỨỪỬỮỰƯ]" },
        { to: "w", from: "[ẂŴẀẄ]" },
        { to: "x", from: "[ẍ]" },
        { to: "y", from: "[ÝŶŸỲỴỶỸ]" },
        { to: "z", from: "[ŹŻŽ]" },
        { to: "-", from: "[·/_,:;']" }
      ];

      sets.forEach(set => {
        text = text.replace(new RegExp(set.from, "gi"), set.to);
      });

      text = text
        .toString()
        .toLowerCase()
        .replace(/\s+/g, "-") // Replace spaces with -
        .replace(/&/g, "-and-") // Replace & with 'and'
        .replace(/[^\w-]+/g, "") // Remove all non-word chars
        .replace(/--+/g, "-") // Replace multiple - with single -
        .replace(/^-+/, "") // Trim - from start of text
        .replace(/-+$/, ""); // Trim - from end of text

      if (typeof separator !== "undefined" && separator !== "-") {
        text = text.replace(/-/g, separator);
      }

      return text;
    }
  }
};
</script>
